import { freeze } from './core/util/Object'

export const immutableEmptyArray = freeze([])
